<template lang="pug">
  .profile-page__main
    .profile-page__body
      .admin-accounts-registry
        .admin-accounts-registry__tabs
          ul.tab-nav
            li.tab-nav__item(
            v-for="(tab, index) in tabs"
            )
              a.tab-nav__link(
              @click.prevent="changeTab(index)"
              :class="{'tab-nav__link_active':tab.isActive}"
              ) {{tab.title}}
        .admin-accounts-registry__button
          .form
            .form__elem.form__elem_button
              router-link.button.button_paint-main--transparent(
              :to="{name: linkForEditor, params: {id: 'create'}}"
              ) Создать учетную запись
        .admin-accounts-registry__table
          accounts-registry-scroll-fix-table(
          :tab-data="tableData"
          :tab-head="tableHead"
          @switch-change="onSwitchChange"
          @on-button-delete-click="onButtonDeleteClick"
          :link-for-editor="linkForEditor"
          )

</template>

<script>
import {mapActions} from "vuex";
import {CampManagerFilterEnums} from "../../../../../const/index.js";
import AccountsRegistryScrollFixTable from "./components/AccountsRegistryScrollFixTable";

export default {
  name: "AdminAccountsRegistry",
  components: {
    AccountsRegistryScrollFixTable
  },
  data() {
    return {
      tabs: [
        {
          title: "Администраторы",
          isActive: true,
          data: []
        },
        {
          title: "Директора баз",
          isActive: false,
          data: []
        }
      ],
      tableHead: [
        {
          title: "ФИО"
        },
        {
          title: "Email"
        }
      ]
    };
  },
  computed: {
    activeTab() {
      const tabIndex = this.tabs.findIndex(item => {
        return item.isActive === true;
      });
      return tabIndex;
    },
    tableData() {
      const data = this.tabs[this.activeTab].data;
      return data;
    },
    linkForEditor() {
      if (this.activeTab === 0) {
        return "AdminAccountsCreateStaffCampgroup";
      }
      return "AdminAccountsCreateStaffCamp";
    }
  },
  methods: {
    ...mapActions([
      "getCampGroupManagers",
      "getCampManagers",
      "updateCampStaff",
      "deleteCampStaff"
    ]),
    changeTab(index) {
      this.tabs.forEach((item, i) => {
        item.isActive = index === i;
      });
    },
    switchChange(item) {
      setTimeout(() => {
        item.is_active = !item.is_active;
        this.updateCampStaff({
          id: item.id,
          data: {
            is_active: item.is_active
          }
        }).then(res => {
          if (res.status !== 200) {
            alert(res.status);
            item.is_active = !item.is_active;
          }
        });
      });
    },
    onSwitchChange(item) {
      if (item.is_active) {
        this.$root.$emit("onShowConfirmModal", {
          text: "При деактивации учётной записи - вход в систему под данным логином будет недоступен.",
          buttonConfirmText: "Продолжить",
          buttonCancelText: "Отмена",
          buttonConfirmFunc: {
            func: this.switchChange,
            params: [item]
          }
        });
      } else {
        this.switchChange(item);
      }
    },
    onButtonDeleteClick(item) {
      this.deleteCampStaff(item.id).then((res) => {
        if (res.status === 204) {
          const index = this.tabs[this.activeTab].data.findIndex((i) => {
            return i.id === item.id;
          });
          this.tabs[this.activeTab].data.splice(index, 1);
        } else if (res.status === 400) {
          this.$root.$emit("onShowErrorModal", {
            // text: res.data.detail.message
            text: "При удалении учётной записи - вы должны назначить другого директора в связанном лагере. Только после этого удаление данной учетной записи будет доступно."
          });
        }
      });
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    const _this = this;
    const getCampGroupManagersPromise = new Promise((resolve, reject) => {
      _this.getCampGroupManagers().then(res => {
        _this.tabs[0].data = res;
        resolve();
      });
    });
    const getCampManagersPromise = new Promise((resolve, reject) => {
      this.getCampManagers(CampManagerFilterEnums.ALL).then(res => {
        this.tabs[1].data = res;
        resolve();
      });
    });
    getCampGroupManagersPromise
      .then(() => {
        return getCampManagersPromise;
      })
      .then(() => {
        this.$root.$emit("on-hide-preloader");
      });
  }
};
</script>
